module.exports = {"220273100":"岔路河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220273.json
// module id = 624
// module chunks = 0